import { lazy } from 'react'
import { Route } from 'commons/types/route'
import { LIST_SHARING_MANAGEMENT } from 'commons/constants/permissions'

const SharingManegementPage = lazy(() => import('pages/SharingManegement'))

export default [
  {
    path: '/sharingManagement',
    component: SharingManegementPage,
    permissions: LIST_SHARING_MANAGEMENT,
  },
] as Route[]
